import styled from 'styled-components';

export const Header = styled.header`
  background-color: #e3f3f7;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: calc(50% - 15px);
    width: 0; 
    height: 0; 
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-top: 15px solid #e3f3f7;
  }
`;

export const LogoAce = styled.div`
  flex: 1;
  align-self: flex-end;
  margin-right: 2.5rem;
  text-align: right;
`;

export const Slogan = styled.div`
  flex: 1;
  align-self: flex-end;
  margin-left: 2.5rem;
  text-align: left;
`;
